import _ from 'lodash';

import COMMON_IMPORTS from './common.imports';

import './locations.bundle.scss';

import commonFiltersMod from './common/filters';
import locationsModule from './locations/locations.component';
import defaultConfigs from './common.config';
import defaultRuns from './common.run';
import translationServiceMod from './common/translation.service';
import urlServiceMod from './common/url.service';

let mod = angular.module('locationsMain', _.union(
  COMMON_IMPORTS,
  defaultConfigs.imports,
  defaultRuns.imports,
  [
    commonFiltersMod,
    locationsModule,
    translationServiceMod,
    urlServiceMod
  ]
)).controller('LocationsBundleController', function ($scope, $compile, $element, $window, TranslationService, UrlService, gettextCatalog) {
  TranslationService.waitForTranslations().finally(() => {

    const city = $element[0].dataset['city'];
    const mapMode = $element[0].dataset['mapMode'];
    const cityAttribute = city ? `city-id="${city}"` : '';
    const mapOrShowCitiesAttribute = mapMode ? 'map-mode="true"' : 'show-cities="true"';
    let selectLocationButtonText = null;

    if (mapMode) {
      selectLocationButtonText = gettextCatalog.getString('Näytä vapaat ajat');

      $scope.onLocationSelected = (location) => {
        return UrlService.reservationURL({locationId: location.id})
          .then((url) => $window.location.href = url);
      };
    } else {
      $scope.onLocationSelected = (location) => $window.location.href = location.url;
    }

    const selectLocationButtonTextAttribute = selectLocationButtonText ? `location-select-custom-text="'${selectLocationButtonText}'"` : '';

    const element = angular.element(`
      <locations show-reserve-link="true"
                 ${mapOrShowCitiesAttribute}
                 ${cityAttribute}
                 location-selected-callback="onLocationSelected(location)"
                 ${selectLocationButtonTextAttribute}>
      </locations>`);
    $compile(element)($scope);

    // Render the locations widget
    $element.append(element);
  });
});

mod = defaultConfigs(mod);
mod = defaultRuns(mod);

export default mod.name;
